import { combineReducers } from "redux";
import {UserReducer} from "./UserReducer";
import {CustomerReducer} from './CustomerReducer';
import {UserGroupReducer} from './UserGroups/UserGroupReducer';
import { DcumentGroupReducer } from "./DocumentGroups/DcumentGroupReducer";
const rootReducer=combineReducers({
    UserReducer:UserReducer,
    CustomerReducer:CustomerReducer,
    UserGroupReducer:UserGroupReducer,
    DocumentGroupReducer:DcumentGroupReducer
})
export default rootReducer